import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 'create',
  class: "feedback__create feedback__transition"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "feedback__create--title text-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Предложите идею для новой привилегии")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "feedback__create--desc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "feedback__create--desc--desktop" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Подробно опишите идею и расскажите, почему именно эту привилегию вы хотите увидеть в списке. Если вас поддерживают коллеги, обязательно об этом напишите — востребованные привилегии рассматривают в первую очередь."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" В конце укажите свой город и СБЕ. Так нам будет проще найти партнёров.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "feedback__create--desc--mobile" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Подробно опишите идею и расскажите, почему именно эту привилегию вы хотите увидеть в списке. Если вас поддерживают коллеги, обязательно об этом напишите — востребованные привилегии рассматривают в первую очередь. В конце укажите свой город и СБЕ. Так нам будет проще найти партнёров.")
  ])
], -1)
const _hoisted_4 = { class: "feedback__create--text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Опишите идею", -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }

import store from '@/store'
import MainMixin from '@/mixins/main'
import FeedBackSuccess from './FeedBackSuccess.vue'
import Loader from '../Loader/Loader.vue'
import { computed, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedBackCreate',
  emits: ['closeContent'],
  setup(__props, { emit }) {



const message = ref('')
const isSuccess = ref(false)
const user = ref(' ')
const back = ref(false)
const delayAnimation = ref(true)

const onBack = () => {
  isSuccess.value = false
  back.value = false
}

const isLoading = computed(() => store.getters.isFeedbackBusy)

const submit = () => {
  store.dispatch('setIsFeedbackBusy', true)
  delayAnimation.value = false
  back.value = true
  store
    .dispatch('createFeedbackItem', {
      userId: user.value?.id,
      feedbackDesc: message.value,
      createdDate: MainMixin.methods.getFormattedDateOriginToTimestamp(''),
    })
    .then(
      () => {
        setTimeout(() => {
          isSuccess.value = true
          delayAnimation.value = true
          message.value = ''
        }, 1000)
      },
      () => {
        isSuccess.value = false
      }
    )
}
onMounted(
  () => (user.value = JSON.parse(localStorage?.getItem('user') as string))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["transition-container", {
      'feedback-success': isSuccess.value && !_unref(isLoading) && delayAnimation.value,
    }])
  }, [
    (!isSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("textarea", {
              placeholder: "Добавьте в список привилегий...",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
            }, null, 512), [
              [_vModelText, message.value]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["feedback__create--footer", { disabled: message.value.length < 5 }])
          }, [
            _createElementVNode("button", {
              onClick: submit,
              disabled: message.value.length < 5,
              class: _normalizeClass({
            loading: !delayAnimation.value,
          })
            }, [
              (
              (_unref(isLoading) || !delayAnimation.value) && (!delayAnimation.value || !isSuccess.value)
            )
                ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "Отправить"))
            ], 10, _hoisted_6)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (isSuccess.value && !_unref(isLoading))
      ? (_openBlock(), _createBlock(FeedBackSuccess, {
          key: 'success',
          onBack: onBack,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('closeContent')))
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})